<template>
    <Collapse v-if="pagedList.length">
        <template slot="title">
            {{tab == SectionTabs.DEPT ? t('selectMember.dept') : t('selectMember.deptMember')}}
        </template>
        <template slot="content">
            <DeptNode 
                v-for="(item, index) in pagedList"
                :key="index"
                :data="item"
                :withMembers="withMembers"
                :showExpand="withMembers"
                @handleExpand="handleExpand"
                @handleChecked="handleChecked" />
            <Load v-if="hasMore" 
                :hasData="!!pagedList.length"
                :hasMore="hasMore"
                :loading="loading" 
                @on-load="handleLoad"/>
        </template>
    </Collapse>
</template>

<script>
import { getDeptList, getDeptMemberList } from '../utils';
import Mixin from './mixin';
import DeptNode from '../section/section-dept-node';

export default {
    name: 'SearchDeptResult',
    mixins: [ Mixin ],
    components: {
        DeptNode
    },
    computed: {
        withMembers() {
            return this.tab === this.SectionTabs.DEPT_MEMBER
        },
        deptIds() {
            const { deptList = [], orgId } = this.root
            return deptList && deptList.map((item)=>{
                return item.deptId
            }).join(',') || orgId
        },
        pagedList() {
            return this.list.slice(0, this.page * this.size)
        }
    },
    watch: {
        page(newVal) {
            if (newVal * this.size >= this.list.length) {
                this.hasMore = false;
            }
        }
    },
    methods: {
        handleSearch() {
            this.loading = true;
            const { host, qzId, keyword, chooseDeptType, language, token, deptFirst } = this.root;
            return getDeptList(host, qzId, {
                withMembers: this.withMembers,
                deptIds: this.deptIds,
                // 目前接口不支持组织分页，所以前端分页
                // page: this.page,
                // size: this.size,
                type: chooseDeptType,
                keyword: keyword,
                language: language,
                token: token,
                deptFirst: deptFirst,
                includeChildren: true
            }).then(res => {
                let data = res.data
                if(!Array.isArray(data)) throw new Error();
                data.forEach(item => {
                    item.checked = false;
                    item.expand = false;
                    item.haveSub = false;
                    item.children = [];
                    item.loading = false;
                })
                this.list = data;
                // this.list = this.list.concat(data);
                // this.page ++;
                this.hasMore = data.length >= this.size;
            }).catch(err => {
                this.list = [];
                this.hasMore = true;
            }).finally(() => {
                this.loading = false;
            })
        },
        // 搜索结果只显示一级，不显示下级组织部门，展开后只显示人
        getMemberList(deptId, params, checked) {
            params.loading = true
            const { host, qzId, chooseDeptType, language, security, token } = this.root
            getDeptMemberList(host, qzId, {
                deptIds: deptId,
                page: 1,
                size: 9999,
                type: chooseDeptType,
                language: language,
                security: security,
                token: token,
                includeDuty: true
            }).then(res => {
                let data = res && res.data || []
                data.forEach(item => {
                    item.checked = !!checked
                    item.parent = params;
                    if (checked) {
                        this.root.handleSelected(item)
                    }
                })
                params.children = data
                params.loading = false
            }).catch(error => {
                params.loading = false
            })
        },
        handleExpand(expand, data) {
            data.expand = expand
            if(data.children && data.children.length) return
            this.getMemberList(data.deptId, data)
        },
        handleChecked(checked, data) {
            if(data.loading) return false
            if(!this.withMembers || +data.type === 0) { // 如果只选择组织或者单选人员
                if(checked && 1 + this.root.selectedCount > this.root.limit && this.root.limit != 1) {
                    Message.warning(t('selectMember.maximum'))
                    return false
                }
                data.checked = checked
                this.root.handleSelected(data)
                return true
            }
            if(checked && data.userNum + this.root.selectedCount > this.root.limit) {
                Message.warning(t('selectMember.maximum'))
                return false
            }
            // 按照部门选择人员的时候
            this.$set(data, 'indeterminate', checked)
            // data.indeterminate = checked
            if(data.children && data.children.length) {
                data.children.forEach(item => {
                    item.checked = !!checked
                    this.root.handleSelected(item)
                })
                return true
            } 
            this.getMemberList(data.deptId, data, checked)
            return true;
        },
        handleLoad() {
            this.page++;
        }
    }
}
</script>